import RequestProfile from './RequestProfileContainer.vue';

export { RequestProfile };



// WEBPACK FOOTER //
// ./src/modules/home/requestProfile/index.js